import {
	LineString, MultiLineString,
	Point, MultiPoint,
	Polygon, MultiPolygon,
	GeometryCollection, Circle 
	
} from 'ol/geom';

import { fromExtent, fromCircle } from 'ol/geom/Polygon';

import GeoJSON from 'ol/format/GeoJSON';
import WKT from 'ol/format/WKT';

import { haversineDistance } from './projection';

const convertLineString = (coordinates) => new LineString(coordinates);
const convertMultiLineString = geometries => new MultiLineString(geometries);

const convertPoint = (coordinate) => new Point(coordinate);
const convertMultiPoint = geometries => {
	const multiPoint = new MultiPoint([]);
	
	for( let i = 0; i < geometries.length; i++ ) {
    	multiPoint.appendPoint(geometries[i]);
    }
    
    return multiPoint;
}

const convertPolygon = (coordinate) => new Polygon(coordinate);
const convertMultiPolygon = (geometries) => new MultiPolygon(geometries);
const convertGeometryCollection = (geometries) => new GeometryCollection(geometries);

const isValidWKT = (text, dataProjection, featureProjection) => {
     try {
        new WKT().readGeometry(text, {
            dataProjection: dataProjection,
            featureProjection: featureProjection,
        });   
        
        return true;         
    } catch(e) {
        console.warn(e);
        return false;
    }
}

const fromWKT = (text, dataProjection, featureProjection) => {
	 try {
        return new WKT().readGeometry(text, {
            dataProjection: dataProjection,
            featureProjection: featureProjection,
        });            
    } catch(e) {
        console.warn(e);
    }
}

const toWKT = (geometry, dataProjection, featureProjection) => {
	return new WKT().writeGeometry(geometry, {
        dataProjection: dataProjection,
        featureProjection: featureProjection,
    });    
}


const fromGeoJSON = (geometryText, dataProjection, featureProjection) => {
	 try {
        return new GeoJSON().readGeometry(geometryText, {
            dataProjection: dataProjection,
            featureProjection: featureProjection,
        });            
    } catch(e) {
        console.warn(e);
    }
}

const getLength = (geometry, sourceProj) => {
	let length = 0;
    const coordinates = geometry.getCoordinates();
  
    for (let i = 0, ii = coordinates.length - 1; i < ii; ++i) {
        length += haversineDistance(coordinates[i], coordinates[i + 1], sourceProj);
    }
    
    return length;
}

const getLengthM = (geometry, sourceProj) => {
	const length = getLength(geometry, sourceProj);

	let output;
    if (length > 100) {
        output = (Math.round(length / 1000 * 100) / 100) + ' ' + 'km';
    } else {
        output = (Math.round(length * 100) / 100) + ' ' + 'm';
    }
   
    return output;
}

const interpolatePoint = (path, delta) => {
	const X = 0;
	const Y = 1;
	
    const points = path.getCoordinates();

    const start = points[0];
    // we expect a straight line
    const end = points[points.length - 1];

    // calculate approx. position on map;
    const x = start[X] + ((end[X] - start[X]) * delta);
    const y = start[Y] + ((end[Y] - start[Y]) * delta);
   
    return new Point([x,y]);
}

const bufferedPoint = (center, radius) => {
	const geom = new Circle(center, radius);
	return fromCircle(geom);
}

const createMultiPoint = (geometry) => {
	const data = geometry.getCoordinates();
	return new MultiPoint(data);
}

const geometry = { 
	convertLineString, convertMultiLineString,
	convertPoint, convertMultiPoint,
	convertPolygon, convertMultiPolygon,
	convertGeometryCollection,
	isValidWKT, fromWKT, toWKT, fromGeoJSON,
	getLength, getLengthM,
	interpolatePoint,
	fromExtent, bufferedPoint,
	createMultiPoint
}


export {
	geometry
}